import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CreatePricingDto, UpdatePricingDto } from '../dtos/pricing/pricingDto';

@Injectable({
  providedIn: 'root'
})
export class PricingService {

  private apiUrl = `${environment.apiUrl}/pricing`;

  constructor(private http: HttpClient) {}

  getList(): Observable<any> {
    return this.http.get<any>(this.apiUrl);
  }

  create(entity: CreatePricingDto): Observable<any> {
    return this.http.post(`${this.apiUrl}`, entity);
  }

  update(id: number, entity: UpdatePricingDto): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, entity);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }
}
